/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `default` - default
 * * `new_revision` - new revision
 * * `new_schematisation` - new_schematisation
 * @export
 */
export const ForceAsEnum = {
  DEFAULT: "default",
  NEW_REVISION: "new_revision",
  NEW_SCHEMATISATION: "new_schematisation",
} as const;
export type ForceAsEnum = (typeof ForceAsEnum)[keyof typeof ForceAsEnum];

export function instanceOfForceAsEnum(value: any): boolean {
  for (const key in ForceAsEnum) {
    if (Object.prototype.hasOwnProperty.call(ForceAsEnum, key)) {
      if (ForceAsEnum[key as keyof typeof ForceAsEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ForceAsEnumFromJSON(json: any): ForceAsEnum {
  return ForceAsEnumFromJSONTyped(json, false);
}

export function ForceAsEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForceAsEnum {
  return json as ForceAsEnum;
}

export function ForceAsEnumToJSON(value?: ForceAsEnum | null): any {
  return value as any;
}

export function ForceAsEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ForceAsEnum {
  return value as ForceAsEnum;
}
